import React from "react";
import Box from '@mui/material/Box';
import Client from './components/Client';
import { useSearchParams } from 'react-router-dom';
import { useDataStore } from './dataStore';
import { findLanguage, getLanguageIref, resolveSelectedLanguage } from './i18n';
import {
  fetchMobileText,
  getMobileTextValue,
  MobileHtmlContent,
  MobileStandalonePage,
} from './components/MobileStandalone';

function PaymentWrapper() {
  const [searchParams] = useSearchParams();
  const { languages, selectedLanguage, defaultLanguage, languageReady } = useDataStore();
  const queryLanguage = searchParams.get('language') || searchParams.get('lang') || '';
  const shouldWaitForQueryLanguage = Boolean(queryLanguage) && !languageReady;
  const resolvedQueryLanguage = queryLanguage ? findLanguage(languages, queryLanguage) : null;
  const language = resolvedQueryLanguage || resolveSelectedLanguage(languages, selectedLanguage?.iref, defaultLanguage);

  if (shouldWaitForQueryLanguage) {
    return (
      <MobileStandalonePage center maxWidth={560}>
        <Box sx={{ minHeight: 180 }} />
      </MobileStandalonePage>
    );
  }

  return <PaymentVerification language={language} defaultLanguage={defaultLanguage} />;
}
class PaymentVerification extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      terms: {},
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (
      getLanguageIref(prevProps.language) !== getLanguageIref(this.props.language) ||
      getLanguageIref(prevProps.defaultLanguage) !== getLanguageIref(this.props.defaultLanguage)
    ) {
      this.getData();
    }
  }

  getData() {
    const languageIref = getLanguageIref(this.props.language);
    const payment = fetchMobileText(this.state.client, "PAYMENT_VERIFY", languageIref);

    this.setState({
      terms: payment || {},
    });
  }

  render() {
    const html = getMobileTextValue(
      this.state.terms,
      "",
      this.props.language,
      this.props.defaultLanguage
    );

    return (
      <MobileStandalonePage maxWidth={560}>
        <MobileHtmlContent html={html} />
      </MobileStandalonePage>
    );
  }
}

export default PaymentWrapper;
